module.exports = __webpack_public_path__ + "static/media/prima_capital_obseques_plus_notice_information.3f868f83.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/go/documents/adhesion/prima_capital_obseques_plus_notice_information.pdf
// module id = 831
// module chunks = 40